import { useTranslation } from "react-i18next";
import { TSchemaChatMode } from "../../../../services/api/instances/schemasApi/types";
import { AppButton } from "../../../../shared/components/AppButton";
import styles from "./styles.module.css";
import { AppRadio } from "../../../../shared/components/AppRadioGroup/AppRadio";
import classNames from "classnames";

interface Props {
  chatMode: TSchemaChatMode;
  onChange: (type: TSchemaChatMode) => void;
}

export const SchemaChatMode = ({ chatMode, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles["switch-mode-container"]}>
      <div
        onClick={() => onChange("generate_schema")}
        className={classNames(
          styles["radio-group"],
          chatMode === "generate_schema" && styles["radio-active"],
        )}
      >
        <AppRadio checked={chatMode === "generate_schema"} />
        <div className={styles["radio-label"]}>{t("schemas.work_on_xml")}</div>
      </div>

      <div
        onClick={() => onChange("generate_image")}
        className={classNames(
          styles["radio-group"],
          chatMode === "generate_image" && styles["radio-active"],
        )}
      >
        <AppRadio checked={chatMode === "generate_image"} />
        <div className={styles["radio-label"]}>{t("schemas.work_on_img")}</div>
      </div>
    </div>
  );
};
